import React from 'react';
import styled, { css } from 'styled-components';
import MoneyFormat from './MoneyFormat';
import { logInfo } from '../../utils/logging';

export function getTotalSpending(cart) {
  if (!cart) {
    return 0;
  }

  return cart.discountSpendings?.total_spending ?? cart.original_total_price;
}

export function getDiscount(cart, totalSpending) {
  if (!cart) {
    return 0;
  }
  // check if we have full discount
  if (totalSpending === 0) {
    const discountApplied = cart.discountSpendings?.spendings_per_line_item.some(
      (item) => item.discount_amount > 0,
    );
    if (discountApplied) {
      logInfo('DiscountInfo:getTotalSpending:', 'full discount found');
      return cart.original_total_price;
    }
  }
  const spending = cart.original_total_price - totalSpending;
  return Math.max(spending, 0);
}

export const DiscountInfoGrid = styled.div`
  display: grid;
  grid-template: 1fr 1fr / 1fr 1fr;
  grid-column-gap: 1rem;

  ${({ discountApplied }) =>
    !discountApplied &&
    css`
      grid-template: 1fr / 1fr 1fr;
      .GiftBox-Discount__discount,
      .GiftBox-Discount__discount--value {
        display: none;
      }
    `}

  .GiftBox-Discount__subtotal--value {
    color: ${({ discountApplied }) => (discountApplied ? '#50b83c' : 'black')};
    font-weight: bold;
  }
`;

const DiscountInfo = ({ discountApplied, discount, spending }) => (
  <DiscountInfoGrid
    className="GiftBox-Discount"
    discountApplied={discountApplied}
  >
    <div className="GiftBox-Discount__discount">Discount:</div>
    <div className="GiftBox-Discount__discount--value">
      -
      <MoneyFormat amount={discount / 100} />
    </div>
    <div className="GiftBox-Discount__subtotal">Subtotal:</div>
    <div className="GiftBox-Discount__subtotal--value">
      <MoneyFormat amount={spending / 100} />
    </div>
  </DiscountInfoGrid>
);

export default DiscountInfo;
